import { render, staticRenderFns } from "./Component_InputPrice.vue?vue&type=template&id=70e5327e&scoped=true&"
import script from "./Component_InputPrice.vue?vue&type=script&lang=js&"
export * from "./Component_InputPrice.vue?vue&type=script&lang=js&"
import style0 from "./Component_InputPrice.vue?vue&type=style&index=0&id=70e5327e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5327e",
  null
  
)

export default component.exports